export default "__VITE_ASSET__gmmy4nFn__"